module.exports = __webpack_public_path__ + "staticcomp/img/top.c552ec2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/12/top.jpg
// module id = xNoY
// module chunks = 39